import SignIn from "../views/SignIn.vue";
import SignOut from "../views/SignOut.vue";
export default [
    {
        path: '/connexion',
        name: 'signin',
        component: SignIn,
        meta: {
            layout: 'no-footer',
        }
    },
    {
        path: '/deconnexion',
        name: 'signout',
        component: SignOut,
        meta: {
            layout: 'no-footer',
        }
    },
    {
        path: '/profile',
        name: 'user',
        component: () => import('../views/Profile.vue'),
        meta: {
            requiresAuth: true,
            authorize: ['ROLE_ADMIN','ROLE_MANAGER'],
            layout: 'default',
            breadcrumb: 'mon profile',
            description: 'Gestion profile'
        }
    },
    {
        path: '/premiere-connexion',
        name: 'first-connexion',
        component: () => import('../views/FirstConnexion.vue'),
        meta: {
            requiresAuth: true,
            authorize: ['ROLE_ADMIN','ROLE_MANAGER'],
            layout: 'no-footer',
            breadcrumb: 'première connexion',
            description: 'Première connexion'
        }
    }
]
